/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var Initialize = (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      isMobile: (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) { return true; } else { return false; }})(navigator.userAgent||navigator.vendor||window.opera),
      isTablet : navigator.userAgent.match(/Tablet|iPad/i),
      isIE: null,
      init: function() {
        // JavaScript to be fired on all pages
        svg4everybody();
        Nav.init();
        Top.init();
        $('.collapse').collapse({toggle: false});

        if (!Sage.common.isMobile && !Sage.common.isTablet ) {
          Priory.init();
          RandomSVGS.init();
        }

        this.cross_sell();
        $('.valign').matchHeight({
          byRow: true,
          property: 'height',
          target: null,
          remove: false
        });

        $('.generic_page__gallerywrap').slick({
          byRow: true,
          dots: true,
          arrows:true,
          infinite: true,
          autoplay: true,
          speed: 700,
          lazyLoad: 'ondemand',
          prevArrow: '<span class="arrow--left"><span class="icon-prev" aria-hidden="true"><svg role="img" xml:space="preserve"><title>Previous</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/cartmelpriory/dist/images/sprite.svg#arrow_left"></use></svg></span><span class="sr-only">Previous</span></span>',
          nextArrow: '<span class="arrow--right"><span class="icon-next" aria-hidden="true"><svg role="img" xml:space="preserve"><title>Next</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/cartmelpriory/dist/images/sprite.svg#arrow_right"></use></svg></span><span class="sr-only">Next</span></span>',
          responsive: [{
            breakpoint: 800,
            settings: {
              arrows:false,
              dots: true
            }
          }]
        });
        if (!Sage.common.isMobile && !Sage.common.isTablet) {
          SubMenu.init();
        }


        var scrollTime = 1;
        var scrollDistance = 250;
        if (navigator.appVersion.indexOf("Win")==-1 && !Sage.common.isMobile && !Sage.common.isTablet) {
          $(window).on("mousewheel DOMMouseScroll", function(event){
              event.preventDefault();
              var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
              var scrollTop = $(window).scrollTop();
              var finalScroll = scrollTop - parseInt(delta*scrollDistance);
              TweenMax.to($(window), scrollTime, {
                  scrollTo : { y: finalScroll, autoKill:true },
                      ease: Power1.easeOut,
                      overwrite: 5
                  });
          });
        }


        $('.footer__3leaf svg').height($('footer').height());

        if (!Sage.common.isMobile && !Sage.common.isTablet) {
          emergence.init({
            reset: true,
            elemCushion: 0.35
          });
        } else {
          $('html').addClass('noemergence');
        }

        Sage.common.isIE = function(){
          if (window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {return true; }
          return false;
        }(navigator.userAgent||navigator.vendor||window.opera);

      },
      cross_sell: function() {
        $('.generic_page_cross_sell__wrap').click(function() {
          alink = $(this).children('div').children('.table').children('.table-cell').children('a');
          page = alink.attr('href');
          if(page.includes(location.hostname) ) {
            window.location = page;
          } else {
            window.open(page);
          }

        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadPage: function(name, page) {
      Sage[name] = page;
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  return UTIL;

})(jQuery); // Fully reference jQuery after this point.
